import { EMAIL_UNSUBSCRIBE } from 'constants/esDataTypes';
import {
  ResourceType,
  STATIC_LIST_TYPES,
  TRIGGER_METADATA,
  WORKFLOW_TRIGGERS,
} from 'modules/workflows/constants';
import { EVENT_TYPES } from 'utils/dataTypes';
import { LIST_MEMBERSHIP_SINGLE } from 'utils/fieldConstants';

export const SYSTEM_EVENTS = [
  WORKFLOW_TRIGGERS.ADDED_ITEM_TO_CART,
  WORKFLOW_TRIGGERS.PURCHASED,
  // will add List Subscribe/Unsubscribe when we're ready to support them
  WORKFLOW_TRIGGERS.SUBSCRIBED_TO_LIST,
  WORKFLOW_TRIGGERS.UNSUBSCRIBED_FROM_LIST,
  WORKFLOW_TRIGGERS.OPENED_AN_EMAIL,
  WORKFLOW_TRIGGERS.CLICKED_AN_EMAIL,
  WORKFLOW_TRIGGERS.SEND_AN_EMAIL,
  WORKFLOW_TRIGGERS.RECEIVED_AN_SMS,
  // 'OpenedPushTrigger',
  WORKFLOW_TRIGGERS.CLICKED_AN_IN_APP,
  // 'ClosedAnInAppTrigger',
  // 'DeletedAnInAppTrigger',
  // 'DeliveredAnInAppTrigger',
  WORKFLOW_TRIGGERS.OPENED_AN_IN_APP,
  WORKFLOW_TRIGGERS.CLICKED_A_WHATSAPP,
  WORKFLOW_TRIGGERS.RECEIVED_A_WHATSAPP,
  WORKFLOW_TRIGGERS.SEEN_WHATS_APP,
];

export const BACKEND_EVENT_NAME = {
  [WORKFLOW_TRIGGERS.ADDED_ITEM_TO_CART]: 'AddedItemToCart',
  [WORKFLOW_TRIGGERS.PURCHASED]: 'Purchased',
  // will add List Subscribe/Unsubscribe when we're ready to support them
  [WORKFLOW_TRIGGERS.SUBSCRIBED_TO_LIST]: 'Subscribed',
  [WORKFLOW_TRIGGERS.UNSUBSCRIBED_FROM_LIST]: 'Unsubscribed',
  [WORKFLOW_TRIGGERS.OPENED_AN_EMAIL]: 'OpenedEmail',
  [WORKFLOW_TRIGGERS.CLICKED_AN_EMAIL]: 'EmailClicked',
  [WORKFLOW_TRIGGERS.RECEIVED_AN_SMS]: 'ReceivedAnSMS',
  // OpenedPushTrigger: 'OpenedPush',
  [WORKFLOW_TRIGGERS.CLICKED_AN_IN_APP]: 'InAppClicked',
  [WORKFLOW_TRIGGERS.OPENED_AN_IN_APP]: 'InAppOpened',
  // ClosedAnInAppTrigger: 'InAppClosed',
  // DeletedAnInAppTrigger: 'InAppDeleted',
  // DeliveredAnInAppTrigger: 'InAppDelivered',
  [WORKFLOW_TRIGGERS.SEND_AN_EMAIL]: 'EmailSend',
  [WORKFLOW_TRIGGERS.CLICKED_A_WHATSAPP]: 'ClickedWhatsApp',
  [WORKFLOW_TRIGGERS.RECEIVED_A_WHATSAPP]: 'ReceivedWhatsApp',
  [WORKFLOW_TRIGGERS.SEEN_WHATS_APP]: 'SeenWhatsApp',
} as Record<string, string>;

// We just need the label and trigger event name.
// Note: SYSTEM_EVENTS contains fewer keys than TRIGGER_METADATA
export const SYSTEM_EVENTS_METADATA = {
  ...TRIGGER_METADATA,
  // extras not supplied by TRIGGER_METADATA
  [WORKFLOW_TRIGGERS.CLOSED_AN_IN_APP]: {
    label: 'In-App Close',
    hasFilter: true,
    dataType: 'closedAndInApp',
  },
  [WORKFLOW_TRIGGERS.DELETED_AN_IN_APP]: {
    label: 'In-App Delete',
    hasFilter: true,
    dataType: 'deletedAnInApp',
  },
  [WORKFLOW_TRIGGERS.DELIVERED_AN_IN_APP]: {
    label: 'In-App Delivery',
    hasFilter: true,
    dataType: 'deliveredAnInApp',
  },
  [WORKFLOW_TRIGGERS.CLICKED_A_WHATSAPP]: {
    label: 'WhatsApp clicked',
    hasFilter: true,
    dataType: 'whatsAppClick',
  },
  [WORKFLOW_TRIGGERS.RECEIVED_A_WHATSAPP]: {
    label: 'WhatsApp received',
    hasFilter: true,
    dataType: 'whatsAppReceived',
  },
  [WORKFLOW_TRIGGERS.SEEN_WHATS_APP]: {
    label: 'WhatsApp seen',
    hasFilter: true,
    dataType: 'whatsAppSeen',
  },
  [WORKFLOW_TRIGGERS.SUBSCRIBED_TO_LIST]: {
    dataType: 'emailSubscribe',
    hasFilter: true,
    label: 'Subscribe',
    noResourceHelpText: 'There are no static lists in this project',
    resourceType: ResourceType.List,
    resourceFieldName: LIST_MEMBERSHIP_SINGLE,
    selectPlaceholder: 'Select a list...',
    triggerEventNames: 'emailSubscribe',
    listType: STATIC_LIST_TYPES,
  },
  [WORKFLOW_TRIGGERS.UNSUBSCRIBED_FROM_LIST]: {
    dataType: EMAIL_UNSUBSCRIBE,
    hasFilter: true,
    label: 'Unsubscribe',
    noResourceHelpText: 'There are no static lists in this project',
    resourceType: ResourceType.List,
    resourceFieldName: LIST_MEMBERSHIP_SINGLE,
    selectPlaceholder: 'Select a list...',
    triggerEventNames: EVENT_TYPES.EMAIL_UNSUBSCRIBE,
    listType: STATIC_LIST_TYPES,
  },
};

export const DEFAULT_SEARCH_QUERY = {
  field: '',
  value: '',
  comparatorType: 'string',
};

// rule types from other domains (Exit Rules, Hold Until) must be converted to these
export const RULE_TYPES = {
  CUSTOM_EVENT: 'CustomEventRule',
  SYSTEM_EVENT: 'SystemEventRule',
  USER_PROPERTY: 'UserPropertyRule',
  COMBO_RULE: 'RuleCombo',
  CONVERSION_MET: 'ConversionMetExitRule',
};

export const ITERABLE_PURCHASE_EVENT_NAME = 'iterable_purchase';
